import React from 'react'
import { PropTypes } from 'prop-types'
import { css, StyleSheet } from 'aphrodite'
import { COLOR_WHITE, COLOR_GRAY_LIGHT } from '../../../lib/colors'

const styles = StyleSheet.create({
  row: {
    backgroundColor: COLOR_WHITE,
    padding: '10px 10px',
    borderRight: '0px solid #c3c3c3',
    color: COLOR_GRAY_LIGHT,
  },
})

const TableRow = ({ data }) => {
  return (
    <tr>
      {data?.map((item, index) => (
        <td className={css(styles.row)} key={index}>
          {item}
        </td>
      ))}
    </tr>
  )
}

TableRow.propTypes = {
  data: PropTypes.array,
}

export default TableRow
